import { render, staticRenderFns } from "./SubHeaderInquires.vue?vue&type=template&id=53cd3842&"
import script from "./SubHeaderInquires.vue?vue&type=script&lang=ts&"
export * from "./SubHeaderInquires.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports